'use strict';

var cloneRangeMember = require('./cloneRangeMember');

function Range(start, end) {
  this.start = cloneRangeMember(start);
  this.end   = cloneRangeMember(end);
}

module.exports = Range;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/internal/Range.js
// module id = 373
// module chunks = 0